// //@ts-nocheck
// import { Fragment, useCallback, useEffect, useState } from 'react';
// import { Menu, Transition } from '@headlessui/react';
// import Modal from '../common/Modal';
// import { useAppDispatch } from '../../app/hooks';
// import { createTeamsPayload } from '../../features/pipelineStages/pipelineStagesTypes';
// import { toast } from 'sonner';
// import { createLocation, fetchPipelineStagesList, updateLocation } from '../../features/pipelineStages/pipelineStagesSlice';
// import { Label, Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react'
// import {
//     CheckCircleColorIcon, ChevronDownIcon, ChevronDownIconWhite, CustomCheckIcon,
//     CustomPlusColorIcon, EllipsisHorizontalCircleColorIcon, XCircleColorIcon
// } from '../icons';
// import { baseTeamMemberInviteData } from '../../features/teams/teamsSlice';
// import { useParams } from 'react-router-dom';
// import { updateTeamMemberDetails } from '../../features/teamsMembers/teamsMemberSlice';
// import { fetchJobPipelineDetailsData } from '../../features/hiringpipeline/hiringPipelineSlice';
// import { assignJobPipelineDetailsData, fetchJobPipelineDetailsAssign } from '../../features/pipeline/pipelineSlice';

// interface BoardPageProps {
//     isModalOpen: boolean;
//     setIsModalOpen: (value: boolean) => void;
//     editBoardData?: any;
//     baseId: number;
//     setEditBoardData: (value: any) => void;
//     userId: number;
// }

// const people = [
//     { id: 1, name: 'admin' },
//     { id: 2, name: 'manager' },
//     { id: 3, name: 'member' }
// ];

// // Add member permissions options
// const memberPermissions = [
//     { id: 1, name: 'View Candidates' },
//     { id: 2, name: 'Edit Candidates' },
//     { id: 3, name: 'Schedule Interviews' },
//     { id: 4, name: 'Add Comments' },
//     { id: 5, name: 'View Analytics' }
// ];

// const CreateHiriingPipelineStages: React.FC<BoardPageProps> = ({ isModalOpen, setIsModalOpen, editBoardData, baseId, setEditBoardData, userId, teamId, pipelineData, pipelineDataDetails, editIdSave, editUserId, setPipelineData }) => {
//     const [email, setEmail] = useState('');
//     const [purpose, setPurpose] = useState('');
//     const [color, setColor] = useState('bg-[#3b82f6]');
//     const [checked, setChecked] = useState(false);
//     const [loading, setLoading] = useState(false);
//     const [nameError, setNameError] = useState('');
//     const [purposeError, setPurposeError] = useState('');
//     const dispatch = useAppDispatch();
//     const userStatus = localStorage.getItem('userDetails');
//     const userStatusId = userStatus ? JSON.parse(userStatus) : null;
//     const [baseTeamsData, setBaseTeamsData] = useState<any[]>([]);
//     const [selected, setSelected] = useState(people[0])
//     const { jobId } = useParams<{ jobId: string }>();
//     const [role, setRole] = useState(null)
//     const [selectedPermissions, setSelectedPermissions] = useState<typeof memberPermissions[0][]>([]);
//     const [pipelineStages, setPipelineStages] = useState<any[]>([]);

//     const colorList = [
//         { name: "bg-[#3b82f6]" },
//         { name: "bg-[#6b7280]" },
//         { name: "bg-[#bfdbfe]" },
//         { name: "bg-[#ec4899]" },
//         { name: "bg-[#6366f1]" },
//         { name: "bg-[#eab308]" },
//         { name: "bg-[#22c55e]" },
//         { name: "bg-[#06b6d4]" },
//         { name: "bg-[#dc2626]" },
//     ];

//     // Modified useEffect to only fetch pipeline stages when 'member' role is selected
//     useEffect(() => {
//         const fetchPipelineStages = async () => {
//             if (selected.role || selected.name === 'member') {  // Only fetch when 'member' is selected
//                 try {
//                     const response = await dispatch(
//                         fetchJobPipelineDetailsAssign({
//                             baseId: parseInt(baseId, 10),
//                             userId: userStatusId?.id,
//                             JobId: jobId,
//                         })
//                     ).unwrap();

//                     const formattedStages = response.data.stages?.map((stage: any) => ({
//                         id: stage.id,
//                         name: stage.stage_name,
//                         color: stage.stage_colour,
//                         bucket: stage.bucket
//                     })) || [];

//                     setPipelineStages(formattedStages);
//                 } catch (error: any) {
//                     toast.error(error.message || "Failed to fetch pipeline stages");
//                 }
//             } else {
//                 // Clear pipeline stages when non-member role is selected
//                 setPipelineStages([]);
//                 setSelectedPermissions([]);
//             }
//         };

//         fetchPipelineStages();
//     }, [selected.role, selected.name, dispatch, baseId, jobId, userStatusId?.id]);

//     // Load edit data when available
//     useEffect(() => {
//         if (editBoardData) {
//             setEmail(editBoardData.email || '');
//             setColor(`bg-[${editBoardData.color}]` || 'bg-[#3b82f6]');
//             if (editBoardData) {
//                 setSelected(editBoardData);
//             } else {
//                 setSelected(people[0]); // Default to the first item if no match is found
//             }
//         }
//     }, [editBoardData]);

//     useEffect(() => {
//         const storedData = localStorage.getItem('basePiplineStagesData');
//         if (storedData) {
//             setBaseTeamsData(JSON.parse(storedData));
//         }
//     }, []);

//     const handlePermissionToggle = (permission: typeof memberPermissions[0]) => {
//         setSelectedPermissions(current => {
//             const exists = current.find(p => p.id === permission.id);
//             if (exists) {
//                 return current.filter(p => p.id !== permission.id);
//             }
//             return [...current, permission];
//         });
//     };

//     const handleRemovePermission = (permissionId: number) => {
//         setSelectedPermissions(current =>
//             current.filter(permission => permission.id !== permissionId)
//         );
//     };

//     const handleSave = async (e: any) => {
//         e.preventDefault();
//         setLoading(true);
//         setNameError("");
//         setPurposeError("");

//         if (email.trim().length === 0) {
//             setNameError("Email is required");
//             setLoading(false);
//             return;
//         }
//         // Check if bucket is selected
//         if (!selected || !selected.name) {
//             setPurposeError("Role is required"); // Assuming this error should be shown for bucket
//             setLoading(false);
//             return;
//         }

//         const colorValue = color.substring(color.indexOf("[#") + 1, color.indexOf("]"));

//         try {

//             if (editBoardData) {
//                 const payload: createTeamsPayload = {
//                     base_id: baseId,
//                     team_id: teamId,
//                     user_id: editUserId,
//                     role: selected.name,
//                     stage_id: selected.name === 'member' ? selectedPermissions.map(p => p.id).toString() : undefined

//                 };

//                 const response = await dispatch(updateTeamMemberDetails({
//                     baseId: editIdSave || pipelineDataDetails.teamMembers[0]?.id,
//                     data: payload
//                 })).unwrap()

//                 toast.success('Role updated successfully!');
//                 setIsModalOpen(false);
//                 if (response.status === 200) {
//                     const baseResponse = await dispatch(fetchJobPipelineDetailsData({
//                         baseId: Number(baseId),
//                         JobId: jobId
//                     }));

//                     if (baseResponse && baseResponse.payload) {
//                         const updatedPipelineData = baseResponse.payload;
//                         localStorage.setItem('jobByHiringTeamMembers', JSON.stringify(baseResponse.payload.data.teamMembers))
//                         const updatedMember = updatedPipelineData.data.teamMembers.map((member: any) => {
//                             const localStorageData = JSON.parse(localStorage.getItem('baseMembersDetails') || '{}');
//                             const baseMembers = localStorageData?.data?.baseMembers || [];
//                             const invitedByMember = baseMembers.find((member1: any) =>
//                                 member1.id === member.user_id
//                             );

//                             // Only update the role for the specific member we're editing
//                             if (member.id === editIdSave) {
//                                 return {
//                                     ...member,
//                                     role: selected.name,
//                                     display_name: invitedByMember?.display_name,
//                                     email: invitedByMember?.email,
//                                     id: invitedByMember?.id,
//                                     name: invitedByMember?.name,
//                                     profile_pic: invitedByMember?.profile_pic,
//                                 };
//                             }
//                             // Return the original member data for all other members
//                             return {
//                                 ...member,
//                                 display_name: invitedByMember?.display_name,
//                                 email: invitedByMember?.email,
//                                 id: invitedByMember?.id,
//                                 name: invitedByMember?.name,
//                                 profile_pic: invitedByMember?.profile_pic,
//                             };
//                         });

//                         setPipelineData(updatedMember);
//                     }
//                 }

//             }

//             else {
//                 // Create new team
//                 const response = await dispatch(
//                     baseTeamMemberInviteData({
//                         payload: {
//                             email,
//                             role: selected.name,
//                             team_id: pipelineDataDetails.id,
//                             ...(selectedPermissions.length > 0 && { stage_id: selectedPermissions.map((p) => p.id).toString() }),
//                         },
//                         userId: baseId,
//                         jobID: jobId, // Optional jobID
//                     })
//                 ).unwrap();

//                 // Now response contains the actual data
//                 toast.success('Hiring member add successfully');
//                 setIsModalOpen(false);

//                 if (response.status === 200) {
//                     // Fetch the latest pipeline details after updating the role
//                     const baseResponse = await dispatch(fetchJobPipelineDetailsData({ baseId: Number(baseId), JobId: jobId }));

//                     if (baseResponse && baseResponse.payload) {
//                         const updatedPipelineData = baseResponse.payload;  // Assuming the response contains the updated data
//                         localStorage.setItem('jobByHiringTeamMembers', JSON.stringify(baseResponse.payload.data.teamMembers))
//                         // Find the team member whose role was updated and set the role from response
//                         const updatedMember = updatedPipelineData.data.teamMembers.map((member: any) => {
//                             const localStorageData = JSON.parse(localStorage.getItem('baseMembersDetails') || '{}');
//                             const baseMembers = localStorageData?.data?.baseMembers || [];
//                             const invitedByMember = baseMembers.find((member1: any) => member1.id === member.user_id);

//                             // Matching the member whose user_id is being updated
//                             if (member?.user_id === invitedByMember?.id) {  // Make sure selected has a user_id
//                                 return {
//                                     ...member,
//                                     role: selected.name,
//                                     display_name: invitedByMember?.display_name,
//                                     email: invitedByMember?.email,
//                                     id: invitedByMember?.id,
//                                     name: invitedByMember?.name,
//                                     profile_pic: invitedByMember?.profile_pic,
//                                 };
//                             }
//                             return member;
//                         });

//                         // Update the state with the new pipeline data, including the updated member
//                         setPipelineData(updatedMember);  // Update the teamMembers array
//                     }
//                 }
//             }

//             setIsModalOpen(false);
//             resetForm();

//         } catch (error) {
//             console.error("Failed to save team:", error);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const resetForm = useCallback(() => {
//         if (!editBoardData) { // Only reset if not editing
//             setEmail('');
//             setPurpose('');
//             setSelectedPermissions([]);
//             setPipelineStages([]); // Clear pipeline stages
//             setSelected(people[0]);
//         }
//     }, [editBoardData]);

//     const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//         const { name, value } = e.target;
//         if (name === 'email') {
//             setEmail(value);
//             setNameError(value.trim().length === 0 ? "Email is required" : "");
//         }
//         else if (name === 'purpose') {
//             setPurpose(value);
//             // setPurposeError(value.trim().length === 0 ? "Description is required" : "");
//         }
//     };

//     return (
//         <Modal
//             isOpen={isModalOpen}
//             onClose={() => {
//                 setIsModalOpen(false);
//                 resetForm();
//             }}
//             title={editBoardData ? "Edit Hiring Team" : "Create Hiring team"}
//             onSave={handleSave}
//             loading={loading}
//         >
//             <form action="#" onSubmit={handleSave} className="space-y-6 mt-5">
//                 <div className='flex flex-col gap-y-2'>
//                     <label className='wg-label inline-flex cursor-pointer items-center
//                      gap-1 text-sm font-medium leading-6'>Email</label>
//                     <div className="relative">
//                         <input
//                             id='email'
//                             name='email'
//                             type='email'
//                             disabled={!!editBoardData}  // Disable if editBoardData is present
//                             autoComplete='email'
//                             value={email}
//                             onChange={handleInputChange}
//                             placeholder='Enter Email'
//                             className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-500 disabled:outline-gray-200 sm:text-sm/6"
//                         />

//                     </div>
//                     {nameError && <p className="text-sm text-red-600">{nameError}</p>}

//                     <Listbox value={selected} onChange={setSelected}>
//                         <Label className="wg-label inline-flex cursor-pointer items-center gap-1 text-sm font-medium leading-6">Role</Label>
//                         <div className="relative">
//                             <ListboxButton className="relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-white-900 shadow-sm ring-1
//                         ring-inset ring-gray-300 focus:outline-none  sm:text-sm sm:leading-6">
//                                 <span className="flex items-center capitalize">
//                                     {selected.role || selected.name}
//                                 </span>
//                                 <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
//                                     <ChevronDownIcon />
//                                 </span>
//                             </ListboxButton>

//                             <ListboxOptions
//                                 transition
//                                 className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-opacity-5 focus:outline-none"
//                             >
//                                 {people.map((person) => (
//                                     <ListboxOption
//                                         key={person.id}
//                                         value={person}
//                                         className="group relative cursor-pointer select-none py-2 pl-3 pr-9 text-[#374151] data-[focus]:bg-gray-200 data-[focus]:text-[#374151] text-[14px]"
//                                     >
//                                         <span className="flex items-center">
//                                             <span className={`block truncate capitalize text-[14px]`} >
//                                                 {person.name}
//                                             </span>
//                                         </span>
//                                     </ListboxOption>
//                                 ))}
//                             </ListboxOptions>
//                             {purposeError && <p className="text-sm text-red-600">{purposeError}</p>}
//                         </div>
//                     </Listbox>
//                 </div>

//                 {(selected.role === 'member' || selected.name === 'member' &&
//                     <div className="mt-4">
//                         <label className="wg-label inline-flex cursor-pointer items-center gap-1 text-sm font-medium leading-6">
//                             Add stages
//                         </label>

//                         {/* Selected Stages Chips */}
//                         <div className="flex flex-wrap gap-2 mb-2">
//                             {selectedPermissions.map((stage) => (
//                                 <div
//                                     key={stage.id}
//                                     className="inline-flex items-center gap-2 px-2 py-1 rounded-full bg-indigo-100 text-indigo-700 text-sm"
//                                 >
//                                     {stage.name}
//                                     <button
//                                         type="button"
//                                         onClick={() => handleRemovePermission(stage.id)}
//                                         className="text-indigo-500 hover:text-indigo-700"
//                                     >
//                                         <XCircleColorIcon className="w-4 h-4" />
//                                     </button>
//                                 </div>
//                             ))}
//                         </div>

//                         {/* Stages Dropdown */}
//                         <Listbox
//                             value={selectedPermissions}
//                             onChange={setSelectedPermissions}
//                             multiple
//                         >
//                             <div className="relative mt-1">
//                                 <ListboxButton className="relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none sm:text-sm sm:leading-6">
//                                     <span className="block truncate">
//                                         Select stages
//                                     </span>
//                                     <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
//                                         <ChevronDownIcon />
//                                     </span>
//                                 </ListboxButton>

//                                 <ListboxOptions className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
//                                     {pipelineStages.map((stage) => (
//                                         <ListboxOption
//                                             key={stage.id}
//                                             value={stage}
//                                             className="relative cursor-pointer select-none py-2 pl-3 pr-3 text-gray-900 hover:bg-indigo-50"
//                                         >
//                                             {({ selected }) => (
//                                                 <>
//                                                     <div className="flex items-center justify-between gap-2">
//                                                         <div className='flex items-center gap-x-2'>
//                                                             <span className=' shrink-0 w-[9px] h-[9px] block rounded-full' style={{ background: stage.color }}>

//                                                             </span>
//                                                             <span className={`block capitalize truncate ${selected ? 'font-medium' : 'font-normal'}`}>
//                                                                 {stage.name}
//                                                             </span>
//                                                         </div>

//                                                         <div className='ml-0'>
//                                                             {
//                                                                 stage.bucket === 'inbox' &&
//                                                                 <span className="inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10">
//                                                                     <svg
//                                                                         xmlns="http://www.w3.org/2000/svg"
//                                                                         width={16}
//                                                                         height={16}
//                                                                         viewBox="0 0 24 24"
//                                                                         fill="none"
//                                                                         stroke="#4b5563"
//                                                                         strokeWidth={2}
//                                                                         strokeLinecap="round"
//                                                                         strokeLinejoin="round"
//                                                                         className="icon icon-tabler icons-tabler-outline icon-tabler-circle-plus text-[#4b5563] mr-2 w-[1rem] h-[1rem]"
//                                                                     >
//                                                                         <path stroke="none" d="M0 0h24v24H0z" fill="none" />
//                                                                         <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
//                                                                         <path d="M9 12h6" />
//                                                                         <path d="M12 9v6" />
//                                                                     </svg>
//                                                                     Inbox
//                                                                 </span>
//                                                             }
//                                                             {
//                                                                 stage.bucket === 'screening' &&
//                                                                 <span className="inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10">
//                                                                     <svg
//                                                                         xmlns="http://www.w3.org/2000/svg"
//                                                                         width={16}
//                                                                         height={16}
//                                                                         viewBox="0 0 24 24"
//                                                                         fill="none"
//                                                                         stroke="#4338ca"
//                                                                         strokeWidth={2}
//                                                                         strokeLinecap="round"
//                                                                         strokeLinejoin="round"
//                                                                         className="icon icon-tabler icons-tabler-outline icon-tabler-dots-circle-horizontal text-[#4338ca] mr-2 w-[1rem] h-[1rem]"
//                                                                     >
//                                                                         <path stroke="none" d="M0 0h24v24H0z" fill="none" />
//                                                                         <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
//                                                                         <path d="M8 12l0 .01" />
//                                                                         <path d="M12 12l0 .01" />
//                                                                         <path d="M16 12l0 .01" />
//                                                                     </svg>
//                                                                     Screening
//                                                                 </span>
//                                                             }
//                                                             {
//                                                                 stage.bucket === 'hired' &&
//                                                                 <span className="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20">
//                                                                     <svg
//                                                                         xmlns="http://www.w3.org/2000/svg"
//                                                                         width={16}
//                                                                         height={16}
//                                                                         viewBox="0 0 24 24"
//                                                                         fill="none"
//                                                                         stroke="#15803d"
//                                                                         strokeWidth={2}
//                                                                         strokeLinecap="round"
//                                                                         strokeLinejoin="round"
//                                                                         className="icon icon-tabler icons-tabler-outline icon-tabler-circle-check text-[#15803d] mr-2 w-[1rem] h-[1rem]"
//                                                                     >
//                                                                         <path stroke="none" d="M0 0h24v24H0z" fill="none" />
//                                                                         <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
//                                                                         <path d="M9 12l2 2l4 -4" />
//                                                                     </svg>
//                                                                     Hired
//                                                                 </span>
//                                                             }
//                                                             {
//                                                                 stage.bucket === 'reject' &&
//                                                                 <span className="inline-flex items-center rounded-md bg-red-50 px-2 py-1 text-xs font-medium text-red-700 ring-1 ring-inset ring-red-600/10">
//                                                                     <svg
//                                                                         xmlns="http://www.w3.org/2000/svg"
//                                                                         width={16}
//                                                                         height={16}
//                                                                         viewBox="0 0 24 24"
//                                                                         fill="none"
//                                                                         stroke="#b91c1c"
//                                                                         strokeWidth={2}
//                                                                         strokeLinecap="round"
//                                                                         strokeLinejoin="round"
//                                                                         className="icon icon-tabler icons-tabler-outline icon-tabler-circle-x text-[#b91c1c] mr-2 w-[1rem] h-[1rem]"
//                                                                     >
//                                                                         <path stroke="none" d="M0 0h24v24H0z" fill="none" />
//                                                                         <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
//                                                                         <path d="M10 10l4 4m0 -4l-4 4" />
//                                                                     </svg>
//                                                                     Reject
//                                                                 </span>
//                                                             }
//                                                         </div>

//                                                     </div>

//                                                     {selected && (
//                                                         <span className="absolute inset-y-0 right-0 flex items-center pr-3 text-indigo-600">
//                                                             <CustomCheckIcon className="w-5 h-5" />
//                                                         </span>
//                                                     )}
//                                                 </>
//                                             )}
//                                         </ListboxOption>
//                                     ))}
//                                 </ListboxOptions>
//                             </div>
//                         </Listbox>
//                     </div>
//                 )}

//             </form>
//         </Modal>
//     );
// };

// export default CreateHiriingPipelineStages;

//@ts-nocheck
import { Fragment, useCallback, useEffect, useState } from "react";
import { Menu, Transition } from "@headlessui/react";
import Modal from "../common/Modal";
import { useAppDispatch } from "../../app/hooks";
import { createTeamsPayload } from "../../features/pipelineStages/pipelineStagesTypes";
import { toast } from "sonner";
import {
  createLocation,
  fetchPipelineStagesList,
  updateLocation,
} from "../../features/pipelineStages/pipelineStagesSlice";
import {
  Label,
  Listbox,
  ListboxButton,
  ListboxOption,
  ListboxOptions,
} from "@headlessui/react";
import {
  CheckCircleColorIcon,
  ChevronDownIcon,
  ChevronDownIconWhite,
  CustomCheckIcon,
  CustomPlusColorIcon,
  EllipsisHorizontalCircleColorIcon,
  XCircleColorIcon,
} from "../icons";
import {
  baseTeamMemberInviteData,
  fetchBoardsList,
} from "../../features/teams/teamsSlice";
import { useParams } from "react-router-dom";
import { updateTeamMemberDetails } from "../../features/teamsMembers/teamsMemberSlice";
import {
  assignJobPipelineDetailsData,
  fetchJobPipelineDetailsData,
} from "../../features/hiringpipeline/hiringPipelineSlice";
import { fetchJobPipelineDetailsAssign } from "../../features/pipeline/pipelineSlice";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { CrossIcon, ExclamationIcon } from "../icons/Icons";
import { getColorForLabel } from "../../utils/colorUtils";
import {
  baseMemberDetailsData,
  baseMemberDetailsDataStatus1,
} from "../../features/base/baseSlice";
import { _baseRequest, COMMON } from "../../utils/baseApi";

interface BoardPageProps {
  isModalOpen: boolean;
  setIsModalOpen: (value: boolean) => void;
  editBoardData?: any;
  baseId: number;
  setEditBoardData: (value: any) => void;
  userId: number;
}

const people = [
  { id: 1, name: "admin" },
  { id: 2, name: "manager" },
  { id: 3, name: "member" },
];

const peopleNew = [
  { id: 1, name: "admin" },
  { id: 2, name: "manager" },
  { id: 3, name: "member" },
];

// Add member permissions options
const memberPermissions = [
  { id: 1, name: "View Candidates" },
  { id: 2, name: "Edit Candidates" },
  { id: 3, name: "Schedule Interviews" },
  { id: 4, name: "Add Comments" },
  { id: 5, name: "View Analytics" },
];

const SelectionTabs: React.FC<SelectionTabsProps> = ({
  options,
  value,
  onChange,
}) => {
  return (
    <div className="flex w-full gap-4 my-6">
      {options.map((option, index) => (
        <button
          key={index}
          type="button"
          onClick={() => {
            onChange(option.value);
            // If Clone tab is selected, trigger the API call
            if (option.value === "approval") {
              onChange(option.value);
              // You might want to call the API here or in the parent component
            } else {
              onChange(option.value);
            }
          }}
          className={`flex items-start gap-3 p-4 w-full rounded-lg border text-left transition-colors ${
            value === option.value
              ? "border-indigo-600 bg-indigo-50"
              : "border-gray-200 hover:bg-gray-50"
          }`}
        >
          <div className="text-indigo-600 mt-[2px]">{option.icon}</div>
          <div>
            <div className="font-medium text-gray-900">{option.title}</div>
            <div className="text-sm text-gray-500">{option.description}</div>
          </div>
        </button>
      ))}
    </div>
  );
};

function classNames(...classes: any) {
  return classes.filter(Boolean).join(" ");
}

const CreateHiriingPipelineStages: React.FC<BoardPageProps> = ({
  isModalOpen,
  setIsModalOpen,
  editBoardData,
  setEditBoardData,
  userId,
  teamId,
  saveTeamId,
  pipelineData,
  pipelineDataDetails,
  editIdSave,
  editUserId,
  setPipelineData,
}) => {
  const [email, setEmail] = useState("");
  const [purpose, setPurpose] = useState("");
  const [color, setColor] = useState("bg-[#3b82f6]");
  const [checked, setChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [nameError, setNameError] = useState("");
  const [purposeError, setPurposeError] = useState("");
  const dispatch = useAppDispatch();
  const userStatus = localStorage.getItem("userDetails");
  const userStatusId = userStatus ? JSON.parse(userStatus) : null;
  const [baseTeamsData, setBaseTeamsData] = useState<any[]>([]);
  const [selected, setSelected] = useState(people[0]);
  const { baseId, jobId } = useParams<{ baseId: string; jobId: string }>();
  const [role, setRole] = useState(null);
  const [selectedPermissions, setSelectedPermissions] = useState<
    (typeof memberPermissions)[0][]
  >([]);
  const [pipelineStages, setPipelineStages] = useState<any[]>([]);
  const [selectedTab, setSelectedTab] = useState("new");
  const [searchTerm, setSearchTerm] = useState(""); // Add searchTerm state here
  const [jobPipeline, setJobPipeline] = useState<any[]>([]);
  const [selectedTemplate, setSelectedTemplate] = useState<any>(null);
  const [createPipelineLoading, setCreatePipelineLoading] = useState(false);
  const [baseMemberDetails, setBaseMemberDetails] = useState(null);
  const userDetailsData = localStorage.getItem("jobByHiringTeamMembers");
  const baseMembers = userDetailsData ? JSON.parse(userDetailsData) : [];

  const filteredPipelines = baseMemberDetails?.filter((pipeline: any) =>
    pipeline.name.toLowerCase().includes(searchTerm.toLowerCase()),
  );
  const [selectedNew, setSelectedNew] = useState(peopleNew[0]);
  const [isMemberLoading, setIsMemberLoading] = useState(false);
  const [searchTermClone, setSearchTermClone] = useState(""); // Add searchTerm state here
  const [createPipelineLoadingClone, setCreatePipelineLoadingClone] =
    useState(false);
  const [selectedTemplateClone, setSelectedTemplateClone] = useState<any>(null);
  const [createPipelineAssignLoadingSave, setCreatePipelineAssignLoadingSave] =
    useState(false);

  const tabOptions = [
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={20}
          height={20}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          className="icon icon-tabler icons-tabler-outline icon-tabler-square-rounded-plus"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z" />
          <path d="M15 12h-6" />
          <path d="M12 9v6" />
        </svg>
      ),
      title: "Add",
      description: "base member",
      value: "new",
    },
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={20}
          height={20}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          className="icon icon-tabler icons-tabler-outline icon-tabler-copy-plus"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path stroke="none" d="M0 0h24v24H0z" />
          <path d="M7 9.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667z" />
          <path d="M4.012 16.737a2 2 0 0 1 -1.012 -1.737v-10c0 -1.1 .9 -2 2 -2h10c.75 0 1.158 .385 1.5 1" />
          <path d="M11 14h6" />
          <path d="M14 11v6" />
        </svg>
      ),
      title: "Invite",
      description: "by email",
      value: "approval",
    },
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={20}
          height={20}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          className="icon icon-tabler icons-tabler-outline icon-tabler-copy-plus"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path stroke="none" d="M0 0h24v24H0z" />
          <path d="M7 9.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667z" />
          <path d="M4.012 16.737a2 2 0 0 1 -1.012 -1.737v-10c0 -1.1 .9 -2 2 -2h10c.75 0 1.158 .385 1.5 1" />
          <path d="M11 14h6" />
          <path d="M14 11v6" />
        </svg>
      ),
      title: "Clone",
      description: " hiring team",
      value: "clone",
    },
  ];

  const colorList = [
    { name: "bg-[#3b82f6]" },
    { name: "bg-[#6b7280]" },
    { name: "bg-[#bfdbfe]" },
    { name: "bg-[#ec4899]" },
    { name: "bg-[#6366f1]" },
    { name: "bg-[#eab308]" },
    { name: "bg-[#22c55e]" },
    { name: "bg-[#06b6d4]" },
    { name: "bg-[#dc2626]" },
  ];

  const filteredPipelinesClone = jobPipeline.filter((pipeline: any) =>
    pipeline.name.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  useEffect(() => {
    if (selectedTab === "clone") {
      // Call the API to fetch scorecard list
      const fetchScorecards = async () => {
        setCreatePipelineLoadingClone(true);
        try {
          // Fetch data
          const baseResponse = await dispatch(fetchBoardsList(baseId));

          if (baseResponse?.payload) {
            setJobPipeline(baseResponse.payload.data);
          } else {
            setJobPipeline([]);
          }
        } catch (error) {
          console.error("Error fetching teams:", error);
          setJobPipeline([]);
          toast.error("Failed to fetch pipeline details");
        } finally {
          setCreatePipelineLoadingClone(false);
        }
      };

      fetchScorecards();
    }
  }, [selectedTab, baseId, dispatch]);

  useEffect(() => {
    if (baseId) {
      const fetchData = async () => {
        try {
          const baseResponse = await dispatch(
            baseMemberDetailsDataStatus1({ userId: baseId, status: "active" }),
          );
          if (baseResponse.payload.status === 200) {
            setBaseMemberDetails(baseResponse.payload.data.baseMembers);
          }
        } catch (error) {
          console.error("Error fetching base member details:", error);
        }
      };
      fetchData();
    }
  }, [baseId, dispatch]);

  // Modified useEffect to only fetch pipeline stages when 'member' role is selected
  useEffect(() => {
    const fetchPipelineStages = async () => {
      if (
        selected.role ||
        selected.name === "member" ||
        selectedNew.role ||
        selectedNew.name === "member"
      ) {
        // Only fetch when 'member' is selected
        try {
          const response = await dispatch(
            fetchJobPipelineDetailsAssign({
              baseId: parseInt(baseId, 10),
              userId: userStatusId?.id,
              JobId: jobId,
            }),
          ).unwrap();

          const formattedStages =
            response.data.stages?.map((stage: any) => ({
              id: stage.id,
              name: stage.stage_name,
              color: stage.stage_colour,
              bucket: stage.bucket,
            })) || [];

          setPipelineStages(formattedStages);
        } catch (error: any) {
          toast.error(error.message || "Failed to fetch pipeline stages");
        }
      } else {
        // Clear pipeline stages when non-member role is selected
        setPipelineStages([]);
        setSelectedPermissions([]);
      }
    };

    fetchPipelineStages();
  }, [
    selected.role,
    selected.name,
    dispatch,
    baseId,
    jobId,
    userStatusId?.id,
    selectedNew.role,
    selectedNew.name,
  ]);

  // Load edit data when available
  useEffect(() => {
    if (editBoardData) {
      setEmail(editBoardData.email || "");
      setColor(`bg-[${editBoardData.color}]` || "bg-[#3b82f6]");
      if (editBoardData) {
        setSelected(editBoardData);
      } else {
        setSelected(people[0]); // Default to the first item if no match is found
      }
    }
  }, [editBoardData]);

  useEffect(() => {
    const storedData = localStorage.getItem("basePiplineStagesData");
    if (storedData) {
      setBaseTeamsData(JSON.parse(storedData));
    }
  }, []);

  const handlePermissionToggle = (
    permission: (typeof memberPermissions)[0],
  ) => {
    setSelectedPermissions((current) => {
      const exists = current.find((p) => p.id === permission.id);
      if (exists) {
        return current.filter((p) => p.id !== permission.id);
      }
      return [...current, permission];
    });
  };

  const handleRemovePermission = (permissionId: number) => {
    setSelectedPermissions((current) =>
      current.filter((permission) => permission.id !== permissionId),
    );
  };

  const handleSave = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    setNameError("");
    setPurposeError("");

    if (email.trim().length === 0) {
      setNameError("Email is required");
      setLoading(false);
      return;
    }
    // Check if bucket is selected
    if (!selected || !selected.name) {
      setPurposeError("Role is required"); // Assuming this error should be shown for bucket
      setLoading(false);
      return;
    }

    const colorValue = color.substring(
      color.indexOf("[#") + 1,
      color.indexOf("]"),
    );

    try {
      if (editBoardData) {
        const payload: createTeamsPayload = {
          base_id: baseId,
          team_id: teamId,
          user_id: editUserId,
          role: selected.name,
          stage_id:
            selected.name === "member"
              ? selectedPermissions.map((p) => p.id).toString()
              : undefined,
        };

        const response = await dispatch(
          updateTeamMemberDetails({
            baseId: editIdSave || pipelineDataDetails.teamMembers[0]?.id,
            data: payload,
          }),
        ).unwrap();

        toast.success("Role updated successfully!");
        setIsModalOpen(false);
        if (response.status === 200) {
          const baseResponse = await dispatch(
            fetchJobPipelineDetailsData({
              baseId: Number(baseId),
              JobId: jobId,
            }),
          );

          if (baseResponse && baseResponse.payload) {
            const updatedPipelineData = baseResponse.payload;
            localStorage.setItem(
              "jobByHiringTeamMembers",
              JSON.stringify(baseResponse.payload.data.teamMembers),
            );
            const updatedMember = updatedPipelineData.data.teamMembers.map(
              (member: any) => {
                const localStorageData = localStorage.getItem(
                  "jobByHiringTeamMembers",
                );
                const baseMembers = localStorageData
                  ? JSON.parse(localStorageData)
                  : [];

                const invitedByMember = baseMembers.find(
                  (member1: any) => member1.user_id === member.user_id,
                );

                // Only update the role for the specific member we're editing
                if (member.id === editIdSave) {
                  return {
                    ...member,
                    role: selected.name,
                    display_name: invitedByMember?.display_name,
                    email: invitedByMember?.email,
                    id: invitedByMember?.id,
                    name: invitedByMember?.name,
                    profile_pic: invitedByMember?.profile_pic,
                  };
                }
                // Return the original member data for all other members
                return {
                  ...member,
                  display_name: invitedByMember?.display_name,
                  email: invitedByMember?.email,
                  id: invitedByMember?.id,
                  name: invitedByMember?.name,
                  profile_pic: invitedByMember?.profile_pic,
                };
              },
            );

            setPipelineData(updatedMember);
          }
        }
      } else {
        // Create new team
        const response = await dispatch(
          baseTeamMemberInviteData({
            payload: {
              email,
              role: selected.name,
              team_id: pipelineDataDetails.id,
              ...(selectedPermissions.length > 0 && {
                stage_id: selectedPermissions.map((p) => p.id).toString(),
              }),
            },
            userId: baseId,
            jobID: jobId, // Optional jobID
          }),
        ).unwrap();

        // Now response contains the actual data
        toast.success("Hiring member add successfully");
        setIsModalOpen(false);

        if (response.status === 200) {
          // Fetch the latest pipeline details after updating the role
          const baseResponse = await dispatch(
            fetchJobPipelineDetailsData({
              baseId: Number(baseId),
              JobId: jobId,
            }),
          );

          if (baseResponse && baseResponse.payload) {
            const updatedPipelineData = baseResponse.payload; // Assuming the response contains the updated data
            localStorage.setItem(
              "jobByHiringTeamMembers",
              JSON.stringify(baseResponse.payload.data.teamMembers),
            );
            // Find the team member whose role was updated and set the role from response
            const updatedMember = updatedPipelineData.data.teamMembers.map(
              (member: any) => {
                const localStorageData = localStorage.getItem(
                  "jobByHiringTeamMembers",
                );
                const baseMembers = localStorageData
                  ? JSON.parse(localStorageData)
                  : [];

                const invitedByMember = baseMembers.find(
                  (member1: any) => member1.user_id === member.user_id,
                );

                // Matching the member whose user_id is being updated
                if (member?.user_id === invitedByMember?.id) {
                  // Make sure selected has a user_id
                  return {
                    ...member,
                    role: selected.name,
                    display_name: invitedByMember?.display_name,
                    email: invitedByMember?.email,
                    id: invitedByMember?.id,
                    name: invitedByMember?.name,
                    profile_pic: invitedByMember?.profile_pic,
                  };
                }
                return member;
              },
            );

            // Update the state with the new pipeline data, including the updated member
            setPipelineData(updatedMember); // Update the teamMembers array
          }
        }
      }

      setIsModalOpen(false);
      resetForm();
    } catch (error) {
      console.error("Failed to save team:", error);
    } finally {
      setLoading(false);
    }
  };

  const resetForm = useCallback(() => {
    if (!editBoardData) {
      // Only reset if not editing
      setEmail("");
      setPurpose("");
      setSelectedPermissions([]);
      setPipelineStages([]); // Clear pipeline stages
      setSelected(people[0]);
    }
  }, [editBoardData]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    if (name === "email") {
      setEmail(value);
      setNameError(value.trim().length === 0 ? "Email is required" : "");
    } else if (name === "purpose") {
      setPurpose(value);
      // setPurposeError(value.trim().length === 0 ? "Description is required" : "");
    }
  };

  const onTemplateSelect = (template: any) => {
    setSelectedTemplate(template);
  };

  const onTemplateSelectClone = (template: any) => {
    setSelectedTemplateClone(template);
  };

  const handleTeamMemberCreate = async () => {
    try {
      setIsMemberLoading(true);
      let fullUrl = `${COMMON.apiBaseUrl()}/v1/teamMember.add?jobID=${jobId}`;
      const payload = {
        base_id: Number(baseId), // convert to number
        team_id: saveTeamId?.id,
        user_id: selectedTemplate?.id,
        role: selectedNew?.name,
        stage_id:
          selectedNew.name === "member"
            ? selectedPermissions.map((p) => p.id).toString()
            : undefined,
      };

      const response = await _baseRequest(fullUrl, "POST", payload);

      if (response.status === 200) {
        toast.success("Add base member successfully");
        setIsModalOpen(false);
        const baseResponse = await dispatch(
          fetchJobPipelineDetailsData({ baseId: Number(baseId), JobId: jobId }),
        );
        if (baseResponse && baseResponse.payload) {
          const updatedPipelineData = baseResponse.payload;
          localStorage.setItem(
            "jobByHiringTeamMembers",
            JSON.stringify(baseResponse.payload.data.teamMembers),
          );
          const updatedMember = updatedPipelineData.data.teamMembers.map(
            (member: any) => {
              const localStorageData = localStorage.getItem(
                "jobByHiringTeamMembers",
              );
              const baseMembers = localStorageData
                ? JSON.parse(localStorageData)
                : [];
              const invitedByMember = baseMembers.find(
                (member1: any) => member1.user_id === member.user_id,
              );
              return {
                ...member,
                display_name: invitedByMember?.display_name,
                email: invitedByMember?.email,
                id: invitedByMember?.id,
                name: invitedByMember?.name,
                profile_pic: invitedByMember?.profile_pic,
              };
            },
          );
          setPipelineData(updatedMember);
        }
        resetForm();
      }
      // reset state
      setSelectedNew(peopleNew[0]);

      setSelectedPermissions([]);

      onTemplateSelect(null);
    } catch (error) {
      // It will now safely display "member already exists"
      toast.error(error.message);
      setIsModalOpen(false);
    } finally {
      setIsMemberLoading(false);
    }
  };

  const handleAssignPipeline = async () => {
    if (!baseId || !jobId || !selectedTemplateClone?.id) {
      toast.error("Invalid Base ID, Job ID");
      return;
    }

    setCreatePipelineAssignLoadingSave(true);

    try {
      const response = await dispatch(
        assignJobPipelineDetailsData({
          baseId: parseInt(baseId, 10),
          JobId: jobId,
          userId: selectedTemplateClone.id,
        }),
      );

      if (response.meta.requestStatus === "fulfilled") {
        toast.success("Hiring assigned successfully!");

        const baseResponse = await dispatch(
          fetchJobPipelineDetailsData({
            baseId: Number(baseId),
            JobId: jobId,
          }),
        );

        if (baseResponse && baseResponse.payload) {
          const updatedPipelineData = baseResponse.payload;
          localStorage.setItem(
            "jobByHiringTeamMembers",
            JSON.stringify(baseResponse.payload.data.teamMembers),
          );
          const updatedMember = updatedPipelineData.data.teamMembers.map(
            (member: any) => {
              const localStorageData = localStorage.getItem(
                "jobByHiringTeamMembers",
              );
              const baseMembers = localStorageData
                ? JSON.parse(localStorageData)
                : [];
              const invitedByMember = baseMembers.find(
                (member1: any) => member1.user_id === member.user_id,
              );

              // Only update the role for the specific member we're editing
              if (member.id === editIdSave) {
                return {
                  ...member,
                  role: selected.name,
                  display_name: invitedByMember?.display_name,
                  email: invitedByMember?.email,
                  id: invitedByMember?.id,
                  name: invitedByMember?.name,
                  profile_pic: invitedByMember?.profile_pic,
                };
              }
              // Return the original member data for all other members
              return {
                ...member,
                display_name: invitedByMember?.display_name,
                email: invitedByMember?.email,
                id: invitedByMember?.id,
                name: invitedByMember?.name,
                profile_pic: invitedByMember?.profile_pic,
              };
            },
          );

          setPipelineData(updatedMember);
        }
        setIsModalOpen(false); // Close the modal on success
        setSelectedTemplateClone("");
        // localStorage.setItem('baseTeamsData', JSON.stringify(baseResponseData.payload));
      } else {
        throw new Error(response.payload || "Failed to assign pipeline");
      }
    } catch (error: any) {
      toast.error(error.message || "Failed to assign pipeline");
    } finally {
      setCreatePipelineAssignLoadingSave(false);
    }
  };

  return (
    <Dialog
      open={isModalOpen}
      onClose={setIsModalOpen}
      className="relative z-10"
    >
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 
               data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />
      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="relative transform rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all
                    data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in 
                    sm:my-8 sm:w-full sm:max-w-[550px] sm:p-4 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
            <div className="absolute right-[0px] top-[3px] hidden pr-4 pt-4 sm:block">
              <button
                type="button"
                onClick={() => setIsModalOpen(false)}
                className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
              >
                <span className="sr-only">Close</span>
                <CrossIcon />
              </button>
            </div>
            <div className="flex flex-col gay-y-4">
              <DialogTitle
                as="h3"
                className="text-base font-medium text-gray-900"
              >
                Add hiring team member
              </DialogTitle>
              <div className="border-b border-solid border-[#e3e3e3] mx-[-16px] px-[8px] block py-[8px]"></div>
              <SelectionTabs
                options={tabOptions}
                value={selectedTab}
                onChange={setSelectedTab}
              />

              {selectedTab === "approval" && (
                <form action="#" onSubmit={handleSave} className="space-y-6 ">
                  <div className="flex flex-col gap-y-2">
                    <label
                      className="wg-label inline-flex cursor-pointer items-center
                                gap-1 text-sm font-medium leading-6"
                    >
                      Email
                    </label>
                    <div className="relative">
                      <input
                        id="email"
                        name="email"
                        type="email"
                        disabled={!!editBoardData} // Disable if editBoardData is present
                        autoComplete="email"
                        value={email}
                        onChange={handleInputChange}
                        placeholder="Enter Email"
                        className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-1 focus:-outline-offset-1 focus:outline-indigo-600 disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-500 disabled:outline-gray-200 sm:text-sm/6"
                      />
                    </div>
                    {nameError && (
                      <p className="text-sm text-red-600">{nameError}</p>
                    )}
                    <Listbox value={selected} onChange={setSelected}>
                      <Label className="wg-label inline-flex cursor-pointer items-center gap-1 text-sm font-medium leading-6">
                        Assign Role
                      </Label>
                      <div className="relative">
                        <ListboxButton
                          className="relative w-full rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-white-900 cursor-pointer ring-1 
                                   ring-inset ring-gray-300 focus:outline-none  sm:text-sm sm:leading-6"
                        >
                          <span className="flex items-center capitalize">
                            {selected.role || selected.name}
                          </span>
                          <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                            <ChevronDownIcon />
                          </span>
                        </ListboxButton>

                        <ListboxOptions
                          transition
                          className="absolute z-10 mt-[9px] left-[-0px] bg-white w-full max-h-[200px] overflow-auto
                        rounded-lg border border-border bg-popover p-1 text-popover-foregrounddata-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 
                        data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2
                         data-[side=top]:slide-in-from-bottom-2"
                        >
                          {people.map((person) => (
                            <ListboxOption
                              key={person.id}
                              value={person}
                              className={({ active }) =>
                                classNames(
                                  active
                                    ? "bg-gray-200 text-[#1d2025]"
                                    : "text-gray-900",
                                  "relative flex select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 cursor-pointer",
                                )
                              }
                            >
                              <span className="flex items-center">
                                <span
                                  className={`block truncate capitalize text-[14px]`}
                                >
                                  {person.name}
                                </span>
                              </span>
                            </ListboxOption>
                          ))}
                        </ListboxOptions>
                        {purposeError && (
                          <p className="text-sm text-red-600">{purposeError}</p>
                        )}
                      </div>
                    </Listbox>
                  </div>

                  {selected.role === "member" ||
                    (selected.name === "member" && (
                      <div className="mt-4">
                        <label className="wg-label inline-flex cursor-pointer items-center gap-1 text-sm font-medium leading-6">
                          Add stages
                        </label>

                        {/* Selected Stages Chips */}
                        <div className="flex flex-wrap gap-2 mb-2">
                          {selectedPermissions.map((stage) => (
                            <div
                              key={stage.id}
                              className="inline-flex items-center gap-2 px-2 py-1 rounded-full bg-indigo-100 text-indigo-700 text-sm"
                            >
                              {stage.name}
                              <button
                                type="button"
                                onClick={() => handleRemovePermission(stage.id)}
                                className="text-indigo-500 hover:text-indigo-700"
                              >
                                <XCircleColorIcon className="w-4 h-4" />
                              </button>
                            </div>
                          ))}
                        </div>

                        {/* Stages Dropdown */}
                        <Listbox
                          value={selectedPermissions}
                          onChange={setSelectedPermissions}
                          multiple
                        >
                          <div className="relative mt-1">
                            <ListboxButton className="relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none sm:text-sm sm:leading-6">
                              <span className="block truncate">
                                Select stages
                              </span>
                              <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                <ChevronDownIcon />
                              </span>
                            </ListboxButton>

                            <ListboxOptions
                              className="absolute z-10 mt-[9px] left-[-0px] bg-white w-full max-h-[200px] overflow-auto
                        rounded-lg border border-border bg-popover p-1 text-popover-foreground shadow-lg shadow-black/5 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 
                        data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2
                         data-[side=top]:slide-in-from-bottom-2"
                            >
                              {pipelineStages.map((stage) => (
                                <ListboxOption
                                  key={stage.id}
                                  value={stage}
                                  className={({ active }) =>
                                    classNames(
                                      active
                                        ? "bg-gray-200 text-[#1d2025]"
                                        : "text-gray-900",
                                      "relative flex select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 cursor-pointer",
                                    )
                                  }
                                >
                                  {({ selected }) => (
                                    <>
                                      <div className="flex items-center justify-between gap-2">
                                        <div className="flex items-center gap-x-2">
                                          <span
                                            className=" shrink-0 w-[9px] h-[9px] block rounded-full"
                                            style={{ background: stage.color }}
                                          ></span>
                                          <span
                                            className={`block capitalize truncate ${selected ? "font-medium" : "font-normal"}`}
                                          >
                                            {stage.name}
                                          </span>
                                        </div>

                                        <div className="ml-0">
                                          {stage.bucket === "inbox" && (
                                            <span className="inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10">
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={16}
                                                height={16}
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="#4b5563"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                className="icon icon-tabler icons-tabler-outline icon-tabler-circle-plus text-[#4b5563] mr-2 w-[1rem] h-[1rem]"
                                              >
                                                <path
                                                  stroke="none"
                                                  d="M0 0h24v24H0z"
                                                  fill="none"
                                                />
                                                <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
                                                <path d="M9 12h6" />
                                                <path d="M12 9v6" />
                                              </svg>
                                              Inbox
                                            </span>
                                          )}
                                          {stage.bucket === "screening" && (
                                            <span className="inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10">
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={16}
                                                height={16}
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="#4338ca"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                className="icon icon-tabler icons-tabler-outline icon-tabler-dots-circle-horizontal text-[#4338ca] mr-2 w-[1rem] h-[1rem]"
                                              >
                                                <path
                                                  stroke="none"
                                                  d="M0 0h24v24H0z"
                                                  fill="none"
                                                />
                                                <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
                                                <path d="M8 12l0 .01" />
                                                <path d="M12 12l0 .01" />
                                                <path d="M16 12l0 .01" />
                                              </svg>
                                              Screening
                                            </span>
                                          )}
                                          {stage.bucket === "hired" && (
                                            <span className="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20">
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={16}
                                                height={16}
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="#15803d"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                className="icon icon-tabler icons-tabler-outline icon-tabler-circle-check text-[#15803d] mr-2 w-[1rem] h-[1rem]"
                                              >
                                                <path
                                                  stroke="none"
                                                  d="M0 0h24v24H0z"
                                                  fill="none"
                                                />
                                                <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
                                                <path d="M9 12l2 2l4 -4" />
                                              </svg>
                                              Hired
                                            </span>
                                          )}
                                          {stage.bucket === "reject" && (
                                            <span className="inline-flex items-center rounded-md bg-red-50 px-2 py-1 text-xs font-medium text-red-700 ring-1 ring-inset ring-red-600/10">
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={16}
                                                height={16}
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="#b91c1c"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                className="icon icon-tabler icons-tabler-outline icon-tabler-circle-x text-[#b91c1c] mr-2 w-[1rem] h-[1rem]"
                                              >
                                                <path
                                                  stroke="none"
                                                  d="M0 0h24v24H0z"
                                                  fill="none"
                                                />
                                                <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
                                                <path d="M10 10l4 4m0 -4l-4 4" />
                                              </svg>
                                              Reject
                                            </span>
                                          )}
                                        </div>
                                      </div>

                                      {selected && (
                                        <span className="absolute inset-y-0 right-0 flex items-center pr-3 text-indigo-600">
                                          <CustomCheckIcon className="w-5 h-5" />
                                        </span>
                                      )}
                                    </>
                                  )}
                                </ListboxOption>
                              ))}
                            </ListboxOptions>
                          </div>
                        </Listbox>
                      </div>
                    ))}

                  <span className="border-b border-solid border-[#e3e3e3] mx-[-16px] px-[8px] block py-[6px]"></span>
                  <div className="!mt-4 sm:mt-4 sm:flex sm:flex-row-reverse gap-2">
                    <button
                      type="button"
                      onClick={handleSave}
                      className=" inline-flex shrink-0  justify-center items-center gap-1 rounded-md bg-indigo-600 px-[14px] py-1 h-[32px] text-[13px] font-medium leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    >
                      {loading ? (
                        <div className="flex items-center  gap-[6px]">
                          Save
                          <div className="simple-spinner">
                            <span></span>
                          </div>
                        </div>
                      ) : (
                        "Save"
                      )}
                    </button>
                    <button
                      type="button"
                      onClick={() => setIsModalOpen(false)}
                      className="mt-3 inline-flex w-full justify-center items-center rounded-md bg-white px-[14px] py-2 text-[13px] h-[32px] font-medium text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              )}

              {selectedTab === "new" && (
                <div className="mt-[5px]">
                  <Listbox value={selectedNew} onChange={setSelectedNew}>
                    <Label className="wg-label inline-flex cursor-pointer items-center gap-1 text-sm font-medium leading-6">
                      Assign Role
                    </Label>
                    <div className="relative">
                      <ListboxButton
                        className="relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-white-900  ring-1 
                                   ring-inset ring-gray-300 focus:outline-none  sm:text-sm sm:leading-6"
                      >
                        <span className="flex items-center capitalize">
                          {selectedNew.role || selectedNew.name}
                        </span>
                        <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                          <ChevronDownIcon />
                        </span>
                      </ListboxButton>

                      <ListboxOptions
                        transition
                        className="absolute z-10 mt-[9px] left-[-0px] bg-white w-full max-h-[200px] overflow-auto
                        rounded-lg border border-border bg-popover p-1 text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 
                        data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2
                         data-[side=top]:slide-in-from-bottom-2"
                      >
                        {peopleNew.map((person) => (
                          <ListboxOption
                            key={person.id}
                            value={person}
                            className={({ active }) =>
                              classNames(
                                active
                                  ? "bg-gray-200 text-[#1d2025]"
                                  : "text-gray-900",
                                "relative flex select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 cursor-pointer",
                              )
                            }
                          >
                            <span className="flex items-center">
                              <span
                                className={`block truncate capitalize text-[14px]`}
                              >
                                {person.name}
                              </span>
                            </span>
                          </ListboxOption>
                        ))}
                      </ListboxOptions>
                    </div>
                  </Listbox>

                  {selectedNew.role === "member" ||
                    (selectedNew.name === "member" && (
                      <div className="mt-4">
                        <label className="wg-label inline-flex cursor-pointer items-center gap-1 text-sm font-medium leading-6">
                          Add stages
                        </label>

                        {/* Selected Stages Chips */}
                        <div className="flex flex-wrap gap-2 mb-2">
                          {selectedPermissions.map((stage) => (
                            <div
                              key={stage.id}
                              className="inline-flex items-center gap-2 px-2 py-1 rounded-full bg-indigo-100 text-indigo-700 text-sm"
                            >
                              {stage.name}
                              <button
                                type="button"
                                onClick={() => handleRemovePermission(stage.id)}
                                className="text-indigo-500 hover:text-indigo-700"
                              >
                                <XCircleColorIcon className="w-4 h-4" />
                              </button>
                            </div>
                          ))}
                        </div>

                        {/* Stages Dropdown */}
                        <Listbox
                          value={selectedPermissions}
                          onChange={setSelectedPermissions}
                          multiple
                        >
                          <div className="relative mt-1">
                            <ListboxButton className="relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none sm:text-sm sm:leading-6">
                              <span className="block truncate">
                                Select stages
                              </span>
                              <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                <ChevronDownIcon />
                              </span>
                            </ListboxButton>

                            <ListboxOptions
                              className="absolute z-10 mt-[9px] left-[-0px] bg-white w-full max-h-[200px] overflow-auto
                        rounded-lg border border-border bg-popover p-1 text-popover-foreground shadow-lg shadow-black/5 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 
                        data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2
                         data-[side=top]:slide-in-from-bottom-2"
                            >
                              {pipelineStages.map((stage) => (
                                <ListboxOption
                                  key={stage.id}
                                  value={stage}
                                  className={({ active }) =>
                                    classNames(
                                      active
                                        ? "bg-gray-200 text-[#1d2025]"
                                        : "text-gray-900",
                                      "relative flex select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 cursor-pointer",
                                    )
                                  }
                                >
                                  {({ selected }) => (
                                    <>
                                      <div className="flex items-center justify-between gap-2">
                                        <div className="flex items-center gap-x-2">
                                          <span
                                            className=" shrink-0 w-[9px] h-[9px] block rounded-full"
                                            style={{ background: stage.color }}
                                          ></span>
                                          <span
                                            className={`block capitalize truncate ${selected ? "font-medium" : "font-normal"}`}
                                          >
                                            {stage.name}
                                          </span>
                                        </div>

                                        <div className="ml-0">
                                          {stage.bucket === "inbox" && (
                                            <span className="inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10">
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={16}
                                                height={16}
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="#4b5563"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                className="icon icon-tabler icons-tabler-outline icon-tabler-circle-plus text-[#4b5563] mr-2 w-[1rem] h-[1rem]"
                                              >
                                                <path
                                                  stroke="none"
                                                  d="M0 0h24v24H0z"
                                                  fill="none"
                                                />
                                                <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
                                                <path d="M9 12h6" />
                                                <path d="M12 9v6" />
                                              </svg>
                                              Inbox
                                            </span>
                                          )}
                                          {stage.bucket === "screening" && (
                                            <span className="inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10">
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={16}
                                                height={16}
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="#4338ca"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                className="icon icon-tabler icons-tabler-outline icon-tabler-dots-circle-horizontal text-[#4338ca] mr-2 w-[1rem] h-[1rem]"
                                              >
                                                <path
                                                  stroke="none"
                                                  d="M0 0h24v24H0z"
                                                  fill="none"
                                                />
                                                <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
                                                <path d="M8 12l0 .01" />
                                                <path d="M12 12l0 .01" />
                                                <path d="M16 12l0 .01" />
                                              </svg>
                                              Screening
                                            </span>
                                          )}
                                          {stage.bucket === "hired" && (
                                            <span className="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20">
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={16}
                                                height={16}
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="#15803d"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                className="icon icon-tabler icons-tabler-outline icon-tabler-circle-check text-[#15803d] mr-2 w-[1rem] h-[1rem]"
                                              >
                                                <path
                                                  stroke="none"
                                                  d="M0 0h24v24H0z"
                                                  fill="none"
                                                />
                                                <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
                                                <path d="M9 12l2 2l4 -4" />
                                              </svg>
                                              Hired
                                            </span>
                                          )}
                                          {stage.bucket === "reject" && (
                                            <span className="inline-flex items-center rounded-md bg-red-50 px-2 py-1 text-xs font-medium text-red-700 ring-1 ring-inset ring-red-600/10">
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={16}
                                                height={16}
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="#b91c1c"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                className="icon icon-tabler icons-tabler-outline icon-tabler-circle-x text-[#b91c1c] mr-2 w-[1rem] h-[1rem]"
                                              >
                                                <path
                                                  stroke="none"
                                                  d="M0 0h24v24H0z"
                                                  fill="none"
                                                />
                                                <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
                                                <path d="M10 10l4 4m0 -4l-4 4" />
                                              </svg>
                                              Reject
                                            </span>
                                          )}
                                        </div>
                                      </div>

                                      {selected && (
                                        <span className="absolute inset-y-0 right-0 flex items-center pr-3 text-indigo-600">
                                          <CustomCheckIcon className="w-5 h-5" />
                                        </span>
                                      )}
                                    </>
                                  )}
                                </ListboxOption>
                              ))}
                            </ListboxOptions>
                          </div>
                        </Listbox>
                      </div>
                    ))}

                  <div className="mt-4">
                    {/* <label className='wg-label inline-flex cursor-pointer items-center gap-1 text-sm font-medium leading-6 mt-1.5'>Template Name</label> */}
                    <input
                      type="text"
                      placeholder="Search Template"
                      value={searchTerm}
                      // onKeyDown={handleKeyPress}

                      onChange={(e) => setSearchTerm(e.target.value)}
                      className="px-3 py-[10px] w-[100%] border mt-0 border-gray-200 border-solid  rounded-t-lg text-sm border-b-0 focus:outline-none focus:ring-0 focus:ring-gray-200 focus:border-gray-200"
                    />
                  </div>
                  <div className="overflow-x-hidden">
                    <table className="min-w-full divide-y divide-x divide-gray-200">
                      <tbody className="bg-white divide-y rounded-b-lg block divide-gray-200 border border-solid border-[#e5e7eb] overflow-y-auto max-h-[400px] h-full">
                        {createPipelineLoading ? (
                          <tr className="flex items-center justify-center">
                            <td colSpan={4} className="px-6 py-4 text-center">
                              <div className="flex items-center justify-center relative z-50">
                                <div className="simple-spinner-loader">
                                  <span></span>
                                </div>
                              </div>
                            </td>
                          </tr>
                        ) : filteredPipelines?.length > 0 ? (
                          filteredPipelines.map(
                            (template: any, index: number) => {
                              return (
                                <tr
                                  key={index}
                                  onClick={() => onTemplateSelect(template)}
                                  className={`flex items-center px-2 pt-[6px] pb-[7px] cursor-pointer w-full ${selectedTemplate?.id === template.id ? "bg-indigo-50" : ""}`}
                                >
                                  <div>
                                    <span className="flex items-center gap-x-3">
                                      {template.profile_pic ? (
                                        <img
                                          src={`${process.env.REACT_APP_API_BASE_URL}/${template.profile_pic}`}
                                          alt={`${template.name || "Profile"}`}
                                          className="h-6 w-6 flex-none rounded-full ring-1 ring-gray-900/10"
                                        />
                                      ) : (
                                        <div
                                          style={{
                                            backgroundColor: getColorForLabel(
                                              template.name.charAt(0) || "",
                                            ),
                                          }}
                                          className="w-6 h-6 rounded-full flex items-center justify-center leading-5"
                                        >
                                          <span className="font-medium text-white leading-6">
                                            {template.name.charAt(0)}
                                          </span>
                                        </div>
                                      )}
                                    </span>
                                  </div>

                                  <div className="flex flex-col">
                                    <td
                                      className="px-4 pt-0 pb-[0px] text-[#1b1b1b] text-[13px] font-normal
                          whitespace-nowrap  overflow-hidden text-ellipsis w-[400px] capitalize"
                                    >
                                      {template.name}
                                    </td>
                                    {template.email && (
                                      <td className="px-4 pt-0 pb-0">
                                        <span className="text-[13px] text-[#5c5c5e]  rounded-md px-0 leading-4 capitalize line-clamp-1 max-w-[400px]">
                                          {template.email}
                                        </span>
                                      </td>
                                    )}
                                  </div>
                                </tr>
                              );
                            },
                          )
                        ) : (
                          <tr className="flex items-center justify-center">
                            <td
                              colSpan={4}
                              className="px-6 py-4 text-center text-sm text-gray-500"
                            >
                              <div className="w-full mt-5 flex justify-center items-center flex-col gap-y-3">
                                <ExclamationIcon />
                                <p className="text-[#0000007a] text-[13px]">
                                  No results found
                                </p>
                              </div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  <span className="border-b border-solid border-[#e3e3e3] mx-[-16px] px-[8px] block py-[6px]"></span>
                  <div className="flex items-center justify-end gap-[22px] pt-4 flex-wrap md:flex-nowrap lg:flex-nowrap">
                    <button
                      type="submit"
                      className="inline-flex items-center relative justify-center whitespace-nowrap rounded-md bg-indigo-600 font-medium leading-normal help-btn-setting text-[#fefeff] min-w-[32px] h-[32px] px-[14px] text-[0.8125rem]"
                      onClick={handleTeamMemberCreate}
                    >
                      <div className="flex items-center flex-row-reverse gap-[6px]">
                        {isMemberLoading ? (
                          <div className="flex items-center  gap-[6px]">
                            Create
                            <div className="simple-spinner">
                              <span></span>
                            </div>
                          </div>
                        ) : (
                          "Create"
                        )}
                      </div>
                    </button>
                  </div>
                </div>
              )}
              {selectedTab === "clone" && (
                <div className="mt-6">
                  <div className="mt-0">
                    {/* <label className='wg-label inline-flex cursor-pointer items-center gap-1 text-sm font-medium leading-6 mt-1.5'>Template Name</label> */}
                    <input
                      type="text"
                      placeholder="Search Template"
                      value={searchTermClone}
                      // onKeyDown={handleKeyPress}

                      onChange={(e) => setSearchTermClone(e.target.value)}
                      className="px-3 py-[10px] w-[100%] border mt-0 border-gray-200 border-solid  rounded-t-lg text-sm border-b-0 focus:outline-none focus:ring-0 focus:ring-gray-200 focus:border-gray-200"
                    />
                  </div>
                  <div className="overflow-x-hidden">
                    <table className="min-w-full divide-y divide-x divide-gray-200">
                      <tbody className="bg-white divide-y rounded-b-lg block divide-gray-200 border border-solid border-[#e5e7eb] overflow-y-auto max-h-[400px] h-full">
                        {createPipelineLoadingClone ? (
                          <tr className="flex items-center justify-center">
                            <td colSpan={4} className="px-6 py-4 text-center">
                              <div className="flex items-center justify-center relative z-50">
                                <div className="simple-spinner-loader">
                                  <span></span>
                                </div>
                              </div>
                            </td>
                          </tr>
                        ) : filteredPipelinesClone.length > 0 ? (
                          filteredPipelinesClone.map(
                            (template: any, index: number) => {
                              return (
                                <tr
                                  key={index}
                                  onClick={() =>
                                    onTemplateSelectClone(template)
                                  }
                                  className={`flex items-center px-2 pt-[6px] pb-[7px] cursor-pointer w-full ${selectedTemplateClone?.id === template.id ? "bg-indigo-50" : ""}`}
                                >
                                  <div>
                                    {template?.name && (
                                      <div className="flex shrink-0 pr-0 mt-[0px]">
                                        <span
                                          className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full border-none text-[0.625rem] font-medium text-white capitalize bg-gray-400"
                                          style={{
                                            backgroundColor: template?.color,
                                          }}
                                        >
                                          {template.name[0]}
                                        </span>
                                      </div>
                                    )}
                                  </div>

                                  <div className="flex flex-col">
                                    <td
                                      className="px-4 pt-0 pb-[0px] text-[#1b1b1b] text-[13px] font-normal
                                    whitespace-nowrap  overflow-hidden text-ellipsis w-[400px] capitalize"
                                    >
                                      {template.name}
                                    </td>
                                    {template.description && (
                                      <td className="px-4 pt-0 pb-0 whitespace-nowrap  w-[400px]">
                                        <div className=" flex items-center max-w-fit ">
                                          <span
                                            className="flex items-center gap-[6px] 
                text-[13px] text-[#5c5c5e]  rounded-md px-0 leading-4 capitalize
                "
                                          >
                                            {template.description}
                                          </span>
                                        </div>
                                      </td>
                                    )}
                                  </div>
                                </tr>
                              );
                            },
                          )
                        ) : (
                          <tr className="flex items-center justify-center">
                            <td
                              colSpan={4}
                              className="px-6 py-4 text-center text-sm text-gray-500"
                            >
                              <div className="w-full mt-5 flex justify-center items-center flex-col gap-y-3">
                                <ExclamationIcon />
                                <p className="text-[#0000007a] text-[13px]">
                                  No results found
                                </p>
                              </div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  <span className="border-b border-solid border-[#e3e3e3] mx-[-16px] px-[8px] block py-[6px]"></span>
                  <div className="flex items-center justify-end gap-[22px] pt-4 flex-wrap md:flex-nowrap lg:flex-nowrap">
                    <button
                      type="submit"
                      className="inline-flex items-center relative justify-center whitespace-nowrap rounded-md bg-indigo-600 font-medium leading-normal help-btn-setting text-[#fefeff] min-w-[32px] h-[32px] px-[14px] text-[0.8125rem]"
                      onClick={handleAssignPipeline}
                    >
                      <div className="flex items-center flex-row-reverse gap-[6px]">
                        {createPipelineAssignLoadingSave ? (
                          <div className="flex items-center  gap-[6px]">
                            Create
                            <div className="simple-spinner">
                              <span></span>
                            </div>
                          </div>
                        ) : (
                          "Create"
                        )}
                      </div>
                    </button>
                  </div>
                </div>
              )}
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
};

export default CreateHiriingPipelineStages;
